export default class ItemActividadResumenItemProps {
    valor: number;
    logoIcon: string;
    backgroundColor: string;
    color: string;
    descripcion: string;

    constructor(valor: number, logoIcon: string, backgroundColor: string, color: string, descripcion: string) {
        this.valor = valor;
        this.logoIcon = logoIcon;
        this.backgroundColor = backgroundColor;
        this.color = color;
        this.descripcion = descripcion;
    }
};
